import React from "react"

import {FieldTableCellProps, FieldTableCellState, getTableCellStyle} from "../../../../render/table/table-cell"
import FieldMultiselect from "../../../../generic/multiselect/multiselect"
import FieldMultiselect_TableCellValue from "../../../../generic/multiselect/render/table/value"
import ControlButtonStandard, {ControlButtonType} from "../../../../../gd-components/buttons/control-button/control-button-standard"
import {isBulkSelection} from "../../../../../gd/right-click-menu"
import FieldProto_updateView from "../../../../proto/render/table/function/update-view"

// const debug = "FieldCrmContacts_TableCell"
const debug = false

export default class FieldCrmContacts_TableCell extends React.Component<FieldTableCellProps, FieldTableCellState> {

    constructor(props:FieldTableCellProps) {
        super(props)

        this.state = {
            isHovered   : false,
            showPopover : false
        }
    }

    get canEdit():boolean {
        if (this.props.manager.isReadOnly) return false
        return this.props.field.canEdit(this.props.listItem.item)
    }

    onMouseEnter = () => {
        if (!this.canEdit) return

        if (!this.state.isHovered) this.setState({
            isHovered   : true
        })
    }

    onMouseLeave = () => {
        if (this.state.showPopover) return

        if (this.state.isHovered) this.setState({
            isHovered   : false
        })
    }

    onValueChange(value:any, hidePopover:boolean=true) {
        hidePopover && this.hidePopover()

        // if field has tableCellOnValueChange - use it !!!
        if (this.props.field.fieldParams.tableCellOnValueChange) {
            this.props.field.fieldParams.tableCellOnValueChange(this.props.listItem, value, this.props.manager)
            return
        }

        // Otherwise default = custom field

        this.props.listItem.item.setCustomFieldValue(this.props.field.fieldId, value)
        this.props.listItem.item.save()

        this.props.listItem.updateLastUpdateTime() // otherwise it wont re-render
        FieldProto_updateView(this.props.manager, this.props.field)
    }

    onResetValueClick = (e:React.MouseEvent) => {
        if (isBulkSelection(e)) return
        e.stopPropagation()
        this.onValueChange(null, false)
    }

    onClickAdd = (e: React.MouseEvent) => {
        if (isBulkSelection(e)) return
        if (!this.canEdit) return

        // console.log("add here... ")

        // path - need make sure this accountExists
        let crmAccountId : ID | null = null
        if (this.props.listItem.task.crmAccountId && gd.session.crmAccounts.get(this.props.listItem.task.crmAccountId)) {
            crmAccountId = this.props.listItem.task.crmAccountId
        }

        gd.modals.crm.showSearch('contact', crmAccountId, this.props.listItem.task.crmContactIds, (crmAccountId:ID, crmContactIds:ID[])=>{
            this.onValueChange(crmContactIds, false)
        })
    }

    hidePopover = () => {
        this.setState({
            showPopover     : false,
            isHovered       : false
        })
    }

    // OPTIONS
    onOptionClick = (option:Option, e: React.MouseEvent) => {
        if (isBulkSelection(e)) return
        const field     = this.props.field as unknown as FieldMultiselect
        const model     = this.props.listItem.item

        const newValue  = field.toggleValue(model, option.value)
        this.onValueChange(newValue, false)
    }

    onDeleteOption = (option:Option, e: React.MouseEvent) => {
        if (isBulkSelection(e)) return
        const field     = this.props.field as unknown as FieldMultiselect
        const model     = this.props.listItem.item

        const newValue  = field.removeValue(model, option.value)
        this.onValueChange(newValue)
    }

    renderHovered() {
        const field = this.props.field as unknown as FieldMultiselect

        const classes = Classes("cell-flex ui5-txt-less-important-small", this.props.column.id, {
            'is-hovered'        : this.state.isHovered
        })

        return (
            <>
                <div className={classes} style={getTableCellStyle(this.props)} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave} onClick={this.onClickAdd}>
                    <div className="ui5-field-editable is-hovered size-small w-100-percent h-100-percent">
                        <div className="flex-row-left-center w-100-percent">
                            <FieldMultiselect_TableCellValue model          = {this.props.listItem.item}
                                                             isHovered      = {true}
                                                             onDelete       = {this.onDeleteOption}
                                                             field          = {this.props.field as unknown as FieldMultiselect}
                                                             columnWidth    = {this.props.column.width} />
                        </div>

                        <div className="buttons">
                            {!field.isEmpty(this.props.listItem.item) &&
                                <div className="btn-reset m-r-5" onClick={this.onResetValueClick}/>}
                            <ControlButtonStandard type     = {ControlButtonType.PLUS}
                                                   size     = {24}
                                                   onClick  = {this.onClickAdd}/>
                        </div>
                    </div>

                    {this.state.showPopover &&
                        <field.components.PopoverMenu parent    = {this}
                                                      field     = {this.props.field}
                                                      model     = {this.props.listItem.item}/>}
                </div>
            </>
        )
    }

    renderNotHovered() {
        const classes = Classes("cell-flex ui5-field-editable size-small")

        return (
            <>
                <div className={classes} style={getTableCellStyle(this.props)} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
                    <FieldMultiselect_TableCellValue model          = {this.props.listItem.item}
                                                     isHovered      = {false}
                                                     field          = {this.props.field as unknown as FieldMultiselect}
                                                     columnWidth    = {this.props.column.width} />
                </div>
            </>
        )
    }

    render() {
        if (this.state.isHovered) return this.renderHovered()
        else return this.renderNotHovered()
    }
}



